import Grid from '@mui/material/Grid';

import PageAppBar from '../components/PageAppBar';
import PageFooter from '../components/PageFooter';

import './ColumnLayout.css';

export default function ColumnLayout(props = { childs: [] }) {
  const setCurrentPage = props.setCurrentPage;

  return (
    <div>
      <PageAppBar sx={{ maxHeight: '10vh' }}/>
      <Grid
        container
        spacing={3}
        direction="column"
        alignItems="center"
        // justifyContent="center"
        className="column-layout"
      >
        {props.childs.map((child, index) => (
          <Grid item key={index}>
            <Grid
              container
              spacing={3}
              direction="row"
              justifyContent="center"
              alignItems="center"
              style={{ maxWidth: '80vw'}}
            >
              { child instanceof Array && child.map((row_child, index) => (
                  <Grid item key={index} xs={10} sm={10} md={10} lg={10} xl={10} style={{display: 'contents'}}>
                    {row_child}
                  </Grid>
                ))
              }
              { !(child instanceof Array) && <Grid item key={index} xs={10} sm={10} md={10} lg={10} xl={10} style={{display: 'contents'}}>
                  {child}
                </Grid>
              }
            </Grid>
          </Grid>
          ))}
      </Grid>
      <PageFooter sx={{ maxHeight: '10vh' }}/>
    </div>
  );
}
